import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  card: {
    height: '470px',
    width: '560px',
    borderRadius: '8px',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: '32px 48px 56px',
  },
  cardTitle: {
    ...theme.typography.h3,
    paddingBottom: '36px',
    color: theme.colors.primary.main,
  },
  image: {
    alignSelf: 'center',
    marginBottom: '24px',
  },
  checkYourEmailText: {
    ...theme.typography.h4,
    color: theme.colors.text[900],
    marginBottom: '5px',
  },
  mainText: {
    width: '435px',
    ...theme.typography.body1,
    color: theme.colors.gray[800],
    marginBottom: '16px',
  },
  emailInBold: {
    ...theme.typography.h5,
    color: theme.colors.gray[800],
  },
  footer: {
    ...theme.typography.body1,
    color: theme.colors.gray[800],
  },
  linkColor: {
    color: theme.colors.primary.main,
  },
}));
